import React from 'react';
import './Success.css';

const Success = () => {
    return (
        <div className="success-container">
            <h1>Form Submitted Successfully!</h1>
            <p>Your details have been successfully submitted. Thank you!</p>
        </div>
    );
};

export default Success;